import {TweenMax, Power2, TimelineLite} from "gsap/TweenMax"

if ( $('.dnk-article').length ) {
  $( ".dnk-article" ).each(function() {
    const height_meta = $( this ).find('.dnk-article__meta').outerHeight()
    console.log(height_meta)
    $( this ).find('.dnk-article__main__feather').css({ "height" : `calc(100% - ${height_meta}px)` });
  });
}

const $readMore = $('.dnk-article__readmore')

const tl_expand = new TimelineMax();

$readMore.on('click', function() {
  const $article = $(this).prev()
  expand(tl_expand, $article)
  $(this).fadeOut(250);
});

const expand = (tl, article) => {

  const feather = article.find('.dnk-article__main__feather')
  const height =  article.find('.dnk-article__main').outerHeight()
  const height_meta = article.find('.dnk-article__meta').outerHeight()

  tl.to(article, 0.6, { height: height+height_meta, ease: Power2.easeOut})

  // feather.css('background', 'transparent')
  feather.remove()
}



